"use client"

import {ReactNode} from "react";
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import {DiscordActivityProvider} from "@/src/components/DiscordActivityProvider";
import {DndContext} from "@dnd-kit/core";
import {useIsEmbedded} from "@/src/auth/useIsEmbedded";
import {AuthProvider} from "@/src/auth/AuthProvider";
import {Suspense} from "react";

const queryClient = new QueryClient()

export function ClientProviders(props: { children: ReactNode }) {
    return <QueryClientProvider client={queryClient}>
        <Suspense fallback={null}>
            <ClientProvidersInner>
                {props.children}
            </ClientProvidersInner>
        </Suspense>
    </QueryClientProvider>
}

function ClientProvidersInner(props: { children: ReactNode }) {
    const isEmbedded = useIsEmbedded();
    return <DiscordActivityProvider enabled={isEmbedded}>
        <AuthProvider>
            <DndContext>
                {props.children}
            </DndContext>
        </AuthProvider>
    </DiscordActivityProvider>
}
